import { getAdminMinuteProgramMetricsRetrieveQueryOptions } from "@sidegigllc/api/client";
import { queries as participantsQueries } from "domains/admin/containers/TaskOpsParticipants/queries";
import type { WarmableQuery } from "routing/warmQueries";

type ParticipantsQueriesInput = Parameters<typeof participantsQueries>[0];

export const metricsQuery = () => getAdminMinuteProgramMetricsRetrieveQueryOptions();

export const queries = (input: ParticipantsQueriesInput): Array<WarmableQuery> => [
  metricsQuery(),
  ...participantsQueries(input),
];
